import mqtt, { MqttClient } from 'mqtt';

type Callback = (topicName: string, payload: any) => void;

export class Mqtt {
    static client: MqttClient;
    static listeners: Record<string, Callback> = {};
    static connect() : Promise<boolean> {
        return new Promise((resolve, reject)=> {
        if (!Mqtt.client || Mqtt.client?.disconnected) {
            Mqtt.client = mqtt.connect(`${process.env.REACT_APP_MQTT_BROKER_URL}`, {
                clientId: 'react-client',
                username: process.env.REACT_APP_MQTT_BROKER_USER,
                password: process.env.REACT_APP_MQTT_BROKER_PWD,
               
            });
        }

        Mqtt.client.on('connect', () => {
            console.log('Connected to MQTT');
            resolve(true);
        });

        Mqtt.client.on('error', function (msg) {
            console.error('[BackgroundJob] mqtt.event.error', msg);
        });

        Mqtt.client.on('message', (topic, payload) => {
            const msg = payload.toString();
            var callback = Mqtt.listeners[topic];
            callback(topic, payload);
            console.log(`Received: ${msg}`);
        });
    });
    }

    static disconnect() {
        if( Mqtt.client?.connected )
        {
            Mqtt.client.end();
        }
    }

    static subscribe(topic: string, callback: Callback)
    {
        if( Mqtt.client.connected )
        {
            Mqtt.client.subscribe(topic);
            Mqtt.listeners[topic] = callback;
        }
    }


}
